import { useCallback } from "react";
import {
  useNativeHealthSDK,
  type HealthDataType,
} from "@/hooks/useNativeHealthSDK";

const DEFAULT_PERMISSION_DATA_TYPES: HealthDataType[] = [
  "heart_rate",
  "steps",
  "weight",
  "blood_pressure_systolic",
];

const DEFAULT_FETCH_DATA_TYPES: HealthDataType[] = ["heart_rate", "steps"];

export function useLifestyleHealthSDK() {
  const {
    isConnected,
    hasAnyPermissions,
    isAvailable,
    permissions,
    isLoading,
    error,
    records,
    isFetching,
    requestPermissions,
    fetchHealthData,
    refreshStatus,
    getRecordsByType,
    getLatestRecord,
  } = useNativeHealthSDK();

  const handleConnect = useCallback(() => {
    requestPermissions(DEFAULT_PERMISSION_DATA_TYPES);
  }, [requestPermissions]);

  const handleFetchData = useCallback(() => {
    fetchHealthData({
      dataTypes: DEFAULT_FETCH_DATA_TYPES,
      startDate: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000),
      endDate: new Date(),
      limit: 100,
    });
  }, [fetchHealthData]);

  return {
    // Platform state
    isConnected,
    hasAnyPermissions,
    isAvailable,
    permissions,
    isLoading,
    error,
    // Data state
    records,
    isFetching,
    // Actions
    handleConnect,
    handleFetchData,
    refreshStatus,
    // Helpers
    getRecordsByType,
    getLatestRecord,
  };
}

export default useLifestyleHealthSDK;
